import { render } from "./Gridview.vue?vue&type=template&id=b35dcc22"
import script from "./Gridview.vue?vue&type=script&lang=js"
export * from "./Gridview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__